<template>
  <div class="animated fadeIn col-md-12">
    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-tabs v-show="!isLoading" @input="tabTracker">
      <b-tab :lazy="true" active>
        <template v-slot:title>{{ $lang.base_info }}</template>
        <b-form @submit.prevent="save" v-show="!isLoading" class="mb-5">
          <b-row>
            <b-col class="my-1" cols="12" md="6">
              <div>
                <b>{{ $lang.center_number }} </b>:
                <span class="text-muted"> {{ center_number }} </span>
              </div>
            </b-col>
            <b-col class="my-1" cols="12" md="6">
              <div>
                <b>{{ $lang.center_execute_kind }} </b>:
                <span class="text-muted">
                  {{ pathOr("", ["caption"], center_execute_type) }}
                </span>
              </div>
            </b-col>
            <b-col class="my-1" cols="12" md="6">
              <div>
                <b>{{ $lang.company }} </b>:
                <span class="text-muted"> {{ companyName }} </span>
              </div>
            </b-col>
            <b-col class="my-1" cols="12" md="6">
              <div>
                <b>{{ $lang.term_caption }} </b>:
                <span class="text-muted">
                  {{ pathOr("", ["caption"], term) }}
                </span>
              </div>
            </b-col>
            <b-col class="my-1" cols="12" md="6">
              <div>
                <b>{{ $lang.template }} </b>:
                <span class="text-muted"> {{ template_name }} </span>
              </div>
            </b-col>
            <b-col class="my-1" cols="12" md="6">
              <div>
                <b>{{ $lang.assessment_plan }} </b>:
                <span class="text-muted"> {{ assesmet_plan_name }} </span>
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$lang.caption"
                label-for="caption"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.caption"
                  :rules="$v.caption.$params"
                />
                <b-form-input
                  id="caption"
                  type="text"
                  :autocomplete="$lang.caption"
                  v-model="$v.caption.$model"
                  :state="$v.caption.$dirty ? !$v.caption.$error : null"
                >
                </b-form-input>

                <b-form-invalid-feedback id="caption_feedback"
                  >تعداد ارزیاب‌ها الزامی است
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$lang.start_date"
                label-for="start_date"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.start_date"
                  :rules="$v.start_date.$params"
                />
                <date-picker
                  v-model="$v.start_date.$model"
                  :state="$v.start_date.$dirty ? !$v.start_date.$error : null"
                  format="YYYY/MM/DD"
                  display-format="jYYYY/jMM/jDD"
                  min="1950/01/02"
                  inputReq="true"
                  :class="
                    $v.start_date.$dirty
                      ? $v.start_date.$error
                        ? 'invalid-date'
                        : 'valid-date'
                      : null
                  "
                  :disabled="centerExecuteStatusId !== 1"
                >
                </date-picker>

                <b-form-invalid-feedback id="start_date-feedback">
                  {{ $lang.error_required | replace($lang.start_date) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col
              v-if="pathOr(null, ['value'], center_execute_type_selected) === 1"
              cols="12"
              class="mb-3"
            >
              <b-form-checkbox
                id="begin_center_time"
                v-model="begin_center_time"
                name="begin_center_time"
                value="1"
                unchecked-value="0"
                :disabled="centerExecuteStatusId !== 1"
              >
                {{ $lang.begin_center_time }}
                <span
                  v-b-tooltip.hover
                  :title="$lang.begin_center_time_tooltip"
                >
                  <mdicon name="information" size="20" class="text-info" />
                </span>
              </b-form-checkbox>
            </b-col>
            <b-col class="mb-3" cols="12" md="6">
              <div>
                <b>{{ $lang.start_delay }} </b>:
                <span class="text-muted">
                  {{ startDelay || 0 }} {{ $lang.minute }}
                </span>
              </div>
            </b-col>
            <b-col cols="12" md="12" class="mb-3">
              <b-alert
                show
                variant="info"
                class="text-justify d-block"
                dismissible
              >
                <mdicon name="information" size="20" class="mr-1" />
                <span v-text="$lang.create_parvandeh_alert_message" />
                <br />
                <span v-html="$lang.enter_execute_type_alert" />
              </b-alert>
              <b-form-group>
                <requiredComponent
                  slot="label"
                  :label="`${$lang.enter_execute_type}: `"
                  :rules="$v.center_execute_type_selected.$params"
                />
                <selectFind
                  :options="enter_execute_type_options"
                  v-model="$v.center_execute_type_selected.$model"
                  label="text"
                  id="value"
                  :disabled="centerExecuteStatusId !== 1"
                  :isValid="
                    $v.center_execute_type_selected.$dirty
                      ? !$v.center_execute_type_selected.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :state="
                    $v.center_execute_type_selected.$dirty
                      ? !$v.center_execute_type_selected.$error
                      : null
                  "
                >
                  <div v-if="!$v.center_execute_type_selected.required">
                    {{
                      $lang.error_required | replace($lang.enter_execute_type)
                    }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" class="mb-3">
              <b-form-group>
                <requiredComponent
                  slot="label"
                  :label="`${$lang.person_show_complete_data}: `"
                  :rules="$v.person_show_complete_data_selected.$params"
                  :showInfo="true"
                  :titleText="$lang.person_show_complete_data_tooltip"
                />
                <selectFind
                  :options="person_show_complete_data_options"
                  v-model="$v.person_show_complete_data_selected.$model"
                  label="caption"
                  id="id"
                  :isValid="
                    $v.person_show_complete_data_selected.$dirty
                      ? !$v.person_show_complete_data_selected.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :state="
                    $v.person_show_complete_data_selected.$dirty
                      ? !$v.person_show_complete_data_selected.$error
                      : null
                  "
                >
                  <div v-if="!$v.person_show_complete_data_selected.required">
                    {{
                      $lang.error_required
                        | replace($lang.person_show_complete_data)
                    }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" class="my-3">
              <b-form-group>
                <requiredComponent
                  slot="label"
                  :label="`${$lang.createReportMethod}: `"
                  :rules="$v.report_card_production_method_selected.$params"
                />
                <selectFind
                  :options="reportCardProductionMethodOptions"
                  v-model="$v.report_card_production_method_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.report_card_production_method_selected.$dirty
                      ? !$v.report_card_production_method_selected.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :state="
                    $v.report_card_production_method_selected.$dirty
                      ? !$v.report_card_production_method_selected.$error
                      : null
                  "
                >
                  <div
                    v-if="!$v.report_card_production_method_selected.required"
                  >
                    {{
                      $lang.error_required | replace($lang.createReportMethod)
                    }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="text-right">
              <b-button
                class="mr-2"
                variant="outline-danger"
                @click="handleBack"
              >
                <mdicon name="close" size="20" />
                {{ $lang.cancelButton }}
              </b-button>
              <b-button
                type="submit"
                v-if="isAdmin(parentPermissions)"
                variant="success"
              >
                <mdicon name="check" size="20" />
                {{ $lang.submitButton }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-tab>
      <b-tab :lazy="true">
        <template v-slot:title>{{ $lang.center_executive_person }}</template>
        <b-alert variant="warning" show dismissible>
          {{ $lang.warning_pesron_execute }}
        </b-alert>
        <SearchCard
          :filterCatch="true"
          :hasFilter="true"
          :title="$lang.center_executive_person"
          :url="center_execute_executive_url"
          :html="false"
          ref="center_executive_search"
          order_by="executive_role_id:asc-id:asc"
          :permissions="updateExecutePersonPermissions"
          :hasAdd="
            isAdmin(executePersonPermissions) &&
            !includes(centerExecuteStatusId, [4, 5])
          "
          :extraButtons="extraButtons"
          :defaultViewCount="50"
          @handleAdd="addCenterExecutive"
          @updatePermissions="updateExecutePersonPermissions"
        >
          <template slot="html" slot-scope="{ item }">
            <b-col cols="12" md="12" class="my-1 border-left px-0 py-1">
              <b-row class="m-0">
                <b-col
                  cols="12"
                  md=""
                  :class="{
                    invisible: !pathOr(
                      null,
                      ['person_center_execute_code'],
                      item
                    ),
                  }"
                >
                  <span
                    class="text-primary mr-1"
                    v-b-tooltip.hover
                    :title="`${$lang.created_with}: ${pathOr(
                      '',
                      ['created_by'],
                      item
                    )} ${$lang.at}: ${pathOr(
                      '',
                      ['created_at', 'jalali'],
                      item
                    )}`"
                  >
                    <mdicon name="information" size="20" />
                  </span>
                  <strong v-text="`${$lang.ac_code}: `" />
                  <span
                    v-text="pathOr('', ['person_center_execute_code'], item)"
                  />
                </b-col>
                <b-col cols="12" md="">
                  <strong
                    v-text="
                      `${pathOr('', ['executive_role', 'caption'], item)}: `
                    "
                  />
                  <ProfileBoxPopupWrapper
                    :data="item.parvandeh"
                    deskTopPopupClass="top-230"
                    nameClass="color-complementary"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md=""
                  :class="{
                    invisible: !pathOr(
                      null,
                      ['parvandeh', 'parvandeh_number'],
                      item
                    ),
                  }"
                >
                  <strong v-text="`${$lang.parvandeh_number}: `" />
                  <span
                    v-text="pathOr('', ['parvandeh', 'parvandeh_number'], item)"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              v-if="item.second_assessor_parvandeh"
              cols="12"
              md="12"
              class="my-1 border-left px-0 py-1"
            >
              <b-row class="m-0">
                <b-col cols="12" md="" />
                <b-col cols="12" md="">
                  <strong
                    v-text="
                      `${
                        pathOr(2, ['executive_role', 'id'], item) === 2
                          ? $lang.assessor_replacement
                          : $lang.assistant_ac_manager
                      }: `
                    "
                  />
                  <ProfileBoxPopupWrapper
                    :data="item.second_assessor_parvandeh"
                    deskTopPopupClass="top-230"
                    nameClass="color-complementary"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md=""
                  :class="{
                    invisible: !pathOr(
                      null,
                      ['second_assessor_parvandeh', 'parvandeh_number'],
                      item
                    ),
                  }"
                >
                  <strong v-text="`${$lang.parvandeh_number}: `" />
                  <span
                    v-text="
                      pathOr(
                        '',
                        ['second_assessor_parvandeh', 'parvandeh_number'],
                        item
                      )
                    "
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="12" class="text-md-right text-center p-2">
              <b-row align-v="center" align-h="between">
                <b-col
                  v-if="createReportConditions(item)"
                  cols="12"
                  md="auto"
                  class="d-flex align-items-center my-1"
                >
                  <strong class="mr-2">{{ $lang.create_report }}:</strong>
                  <b-form-checkbox
                    v-model="item.is_create_report"
                    switch
                    :value="true"
                    :unchecked-value="false"
                    @change="patchCreateReport(item)"
                  />
                </b-col>
                <b-col cols="12" md="" class="my-1 flex-end">
                  <b-button
                    v-for="button in availableButtonsPerson(item)"
                    :key="button.name"
                    @click="button.click(item)"
                    class="m-1"
                    size="sm"
                    :variant="button.variant"
                  >
                    <mdicon :name="button.iconName" size="20" />
                    <span v-text="button.text" class="ml-1" />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <div
              class="absent__user text-danger"
              v-if="!!pathOr(false, ['is_absent', 'id'], item)"
              v-text="pathOr('', ['is_absent', 'caption'], item)"
            />
          </template>
        </SearchCard>
        <b-modal
          no-close-on-backdrop
          v-model="view_executive_select"
          size="xl"
          ok-only
          hide-header
        >
          <LoadingSpinner
            :loading="isLoadingExecutive"
            :text="$lang.sending_data"
          />
          <b-row v-if="!isLoadingExecutive">
            <b-col cols="12" v-if="isPlaningPerson === 0">
              <b-form-group
                :label="$lang.person_executive_code"
                label-for="person_executive_code"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.person_executive_code"
                  :rules="$v.person_executive_code.$params"
                />
                <b-form-input
                  id="person_executive_code"
                  type="text"
                  :autocomplete="$lang.person_executive_code"
                  v-model="$v.person_executive_code.$model"
                  :state="
                    $v.person_executive_code.$dirty
                      ? !$v.person_executive_code.$error
                      : null
                  "
                >
                </b-form-input>

                <b-form-invalid-feedback
                  id="assessor_id-feedback"
                  :style="{
                    display: $v.person_executive_code.$error ? 'block' : 'none',
                  }"
                >
                  {{
                    $lang.error_required | replace($lang.person_executive_code)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="title_person"
                label-for="assessor_id"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="title_person"
                  :rules="$v.person_selected.$params"
                  :showInfo="true"
                  :titleText="$lang.person_selected_tooltip"
                />
                <selectAsync
                  :options="persons_options"
                  v-model="$v.person_selected.$model"
                  label="text"
                  :asyncFind="getPersonCombo"
                  :isValid="
                    $v.person_selected.$dirty
                      ? !$v.person_selected.$error
                      : null
                  "
                  :loading="person_loading"
                />
                <b-form-invalid-feedback
                  id="assessor_id-feedback"
                  :style="{
                    display: $v.person_selected.$error ? 'block' : 'none',
                  }"
                >
                  {{
                    $lang.error_required | replace(title_person)
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="includes(modeEditExecutive, [2, 3])">
              <b-form-group
                :label="assessorReplacementTitle"
                label-for="assessor_replacement"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="assessorReplacementTitle"
                  :rules="$v.assessor_replacement.$params"
                />
                <selectAsync
                  :options="assessor_replacement_options"
                  v-model="$v.assessor_replacement.$model"
                  label="text"
                  :asyncFind="getPersonCombo2"
                  :isValid="
                    $v.assessor_replacement.$dirty
                      ? !$v.assessor_replacement.$error
                      : null
                  "
                  :loading="assessor_replacement_loading"
                />
                <b-form-invalid-feedback
                  id="assessor_replacement-feedback"
                  :style="{
                    display: $v.assessor_replacement.$error ? 'block' : 'none',
                  }"
                >
                  {{
                    $lang.error_required | replace(assessorReplacementTitle)
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              v-if="
                !includes(modeEditExecutive, [1, 2]) && executiveMode === 'add'
              "
            >
              <b-form-group
                :label="$lang.roleExecutive"
                label-for="role"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.roleExecutive"
                  :rules="$v.executive_role_id.$params"
                />
                <selectFind
                  :options="role_options"
                  v-model="$v.executive_role_id.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.executive_role_id.$dirty
                      ? !$v.executive_role_id.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.executive_role_id.$error ? 'block' : 'none',
                  }"
                  id="executive_role_id_feedback"
                >
                  {{ $lang.error_required | replace($lang.roleExecutive) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-slot:modal-footer>
            <b-button class="mr-2" variant="outline-danger" @click="closeModal">
              <mdicon name="close" size="20" />
              {{ $lang.cancelButton }}
            </b-button>
            <b-button
              variant="success"
              v-if="modeEditExecutive && isAdmin(executePersonPermissions)"
              @click="edit_executives()"
            >
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
            <b-button
              variant="success"
              v-if="!modeEditExecutive && isAdmin(executePersonPermissions)"
              @click="add_executives()"
            >
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </template>
        </b-modal>
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="absentModal"
          size="xl"
          ok-only
          hide-header
          hide-footer
        >
          <b-card>
            <div slot="header">
              <strong v-text="$lang.set_absent" />
            </div>
            <LoadingSpinner
              :loading="absentLoading"
              :text="$lang.sending_data"
            />
            <b-row v-if="!absentLoading">
              <!-- <b-col cols="12" md="12">
                <b-form-group
                  label-for="set_absent"
                  :label-cols="this.$config.form.labelCol"
                >
                  <b-form-checkbox
                    id="set_absent"
                    v-model="set_absent"
                    :value="1"
                    :unchecked-value="0"
                  >
                    {{ $lang.set_absent }}
                  </b-form-checkbox>
                  <b-form-invalid-feedback id="set_absent-feedback">
                    {{ $lang.error_required | replace($lang.set_absent) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" md="12">
                <b-form-group>
                  <requiredComponent
                    slot="label"
                    :label="$lang.absent_description"
                    :rules="$v.absent_description.$params"
                    for="absent_description"
                  />
                  <b-form-textarea
                    id="absent_description"
                    v-model="$v.absent_description.$model"
                    type="text"
                    autocomplete="off"
                    :rows="4"
                    :placeholder="$lang.absent_description_placeholder"
                    :state="
                      $v.absent_description.$dirty
                        ? !$v.absent_description.$error
                        : null
                    "
                  >
                  </b-form-textarea>

                  <b-form-invalid-feedback id="absent_description-feedback"
                    >{{
                      $lang.error_required | replace($lang.absent_description)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12" class="text-right">
                <b-button
                  class="mr-2"
                  variant="outline-danger"
                  @click="closeSetAbsentModal"
                >
                  <mdicon name="close" size="20" />
                  {{ $lang.cancelButton }}
                </b-button>
                <b-button
                  variant="success"
                  v-if="isAdmin(executePersonPermissions)"
                  @click="setAbsentOrPresent()"
                >
                  <mdicon name="check" size="20" />
                  {{ $lang.submitButton }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-modal>
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="readyReportModal"
          size="md"
          ok-only
          hide-header
          hide-footer
        >
          <ReportFormPerson
            :title="`${$lang.upload_report_for} ${reportPersonName}`"
            resource="center_execute"
            :resourceCode="centerExecuteCode"
            :parvandehCode="parvandehCode"
            @close="readyReportModal = false"
          />
        </b-modal>
        <Confirm
          v-model="confirmData.show"
          :title="confirmData.title"
          :description="confirmData.description"
          :ok-title="$lang.yes"
          :cancel-title="$lang.no"
          :loading="confirmData.loading"
          :loadingSpinnerText="$lang.updating_data"
          dynamicClass=""
          @ok="rebuildReport"
          @cancel="confirmData.show = false"
        />
        <Confirm
          v-model="confirmModal"
          :title="$lang.remove_item"
          :description="$lang.are_you_sure_to_remove_item"
          dynamicClass=""
          :loading="confirmLoading"
          :preventDefault="true"
          :cancel-title="$lang.no"
          :ok-title="$lang.yes"
          @cancel="confirmModal = false"
          @ok="remove_executive"
        />
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="reportsModal"
          size="xl"
          ok-only
          hide-footer
          hide-header
        >
          <ParvandehReportsList
            :parvandehCode="reportParvandehCode"
            :personName="reportPersonName"
            resource="center_execute"
            :resourceCode="centerExecuteCode"
            :saltFileName="`${reportParvandehNumber}_${reportPersonCodeInAc}`"
            @close="reportsModal = false"
          />
        </b-modal>
        <b-modal
          size="lg"
          v-model="reportSettingsModal"
          hide-header
          hide-footer
        >
          <ReportSettings @closeModal="closeReportSettingsModal" />
        </b-modal>
        <Confirm
          v-model="removeReportsConfirmData.show"
          :title="removeReportsConfirmData.title"
          :description="removeReportsConfirmData.description"
          dynamicClass=""
          :loading="removeReportsConfirmData.loading"
          :preventDefault="true"
          :cancel-title="$lang.no"
          :ok-title="$lang.yes"
          @cancel="closeRemoveReportsConfirm"
          @ok="removeAllAcReports"
        />
      </b-tab>
      <b-tab :lazy="true">
        <template v-slot:title>{{ $lang.day_center_room }}</template>
        <Search
          :parentPermissions="parentPermissions"
          :allowCollapse="false"
          :url="roomUrl"
          :title="$lang.day_center_room"
          :order_by="`room_number:asc`"
          config="day_center_room"
          addModalSize="lg"
          :allowFields="$lang.day_center_room_fields"
          removeModalSize="xl"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleAdd="false"
          :visibleViewCount="false"
          :remove_item="remove_room"
          :allowEdit="false"
          :dynamicButtons="buttonsAddDayCenter"
          ref="roomSearch"
        />
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="view_edit_DayCenterRoom"
          size="lg"
          ok-only
          hide-footer
          hide-header
        >
          <EditDayCenterRoom
            :isModal="true"
            :entityId="center_execute_id"
            :room_id="room_id"
            :permissionButton="isAdmin(parentPermissions)"
            @modal-end-up="closeDayCenterRoom"
            @saveRoom="updateRoom"
          />
        </b-modal>
      </b-tab>
      <b-tab :lazy="true">
        <template v-slot:title>{{ $lang.center_execute_activity }}</template>
        <Search
          :parentPermissions="parentPermissions"
          :allowCollapse="false"
          :url="executiveActivityUrl"
          :allowFields="$lang.center_execute_activity_fields"
          :hiddenFields="hiddenFieldsActivity"
          :title="$lang.center_execute_activity"
          config="activity"
          addModalSize="xl"
          removeModalSize="xl"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="false"
          :baseButtonAdd="true"
          :visibleAdd="
            isAdmin(activityPermissions) &&
            !includes(centerExecuteStatusId, [4, 5])
          "
          :remove_item="remove_activity"
          :allowEdit="false"
          :dynamicButtons="buttonsActivity"
          ref="activitySearch"
          :order_by="`id:asc`"
          @handleAdd="ActivityAddModal"
          @getPermisson="updateActivityPermissions"
        />
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="view_activity"
          size="xl"
          ok-only
          hide-footer
          hide-header
        >
          <b-card>
            <div slot="header">
              <strong v-text="activityFormTitle" />
            </div>
            <LoadingSpinner :loading="modalLoading" :text="modalLoadingText" />
            <ActivityForm
              v-show="!modalLoading"
              :itemId="itemActivityId"
              :parentId="center_execute_id"
              :mode="mode_activity"
              :permissionBtn="isAdmin(parentPermissions)"
              :keyAction="keyAction"
              :keyService="keyService"
              :keyIndex="keyAction"
              :showUpload="true"
              :showStateDefine="false"
              :showRoleCombo="false"
              :term_id="termId"
              :term_code="termCode"
              @submit="submit"
              @cancel="chancelActivity"
              @setResponseCode="setResponseCode"
            />
          </b-card>
        </b-modal>
      </b-tab>
      <b-tab :lazy="true">
        <template v-slot:title>{{ $lang.determine_prerequisites }}</template>
        <template>
          <ListChecked
            v-if="pathOr(null, ['id'], center_execute_type) === 1"
            :isLoading="loading_exercise_prerequisites"
            :items="items_exercise_prerequisites"
            :allowCollapse="false"
            :title="$lang.determine_prerequisites"
            :value="`id`"
            :text="`name`"
            @itemSelected="checkedExercisePrerequisites"
            :parentPermissions="parentPermissions"
          />
          <b-alert v-else show variant="info">
            <mdicon name="information" size="20" class="mr-1" />
            <span v-text="$lang.preExerciseAlertMessage" />
          </b-alert>
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import ListChecked from "./listChecked";
import { required, requiredIf } from "vuelidate/lib/validators";
import Search from "@/components/base/search";
import EditDayCenterRoom from "../day_center_room/editDayCenterRoom";
import ActivityForm from "@/components/base/ActivityForm";
import ReportFormPerson from "@/components/global/ReportFormPerson";
import ParvandehReportsList from "@/components/global/ParvandehReportsList";
import Confirm from "@/components/base/confirm";
import SearchCard from "@/components/base/searchCard";
import ReportSettings from "./components/ReportSettings.vue";
import { pathOr, includes } from "ramda";
import { generateApiUrl, renderEumOptions, isAdmin } from "@/shared/utils";

export default {
  name: "edit-center-execute",
  components: {
    Search,
    datePicker: VuePersianDatetimePicker,
    EditDayCenterRoom,
    ActivityForm,
    ListChecked,
    LoadingSpinner,
    ReportFormPerson,
    ParvandehReportsList,
    Confirm,
    SearchCard,
    ReportSettings,
    ProfileBoxPopupWrapper,
  },
  inject: ["attachmentTempFinalRepository"],
  validations: {
    person_executive_code: {
      required: requiredIf(
        (vm) => !vm.modeEditExecutive || vm.isPlaningPerson === 0
      ),
    },
    person_selected: { required },
    person_show_complete_data_selected: {},
    assessor_replacement: {},
    executive_role_id: { required: requiredIf((vm) => !vm.modeEditExecutive) },
    start_date: {},
    caption: { required: requiredIf((vm) => !vm.modeEditExecutive) },
    report_card_production_method_selected: {
      required: requiredIf((vm) => !vm.executiveMode === "edit"),
    },
    center_execute_type_selected: {
      required: requiredIf((vm) => !vm.executiveMode === "edit"),
    },
    absent_description: { requiredIf: requiredIf((vm) => vm.absentModal) },
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
    company_name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      caption: null,
      center_number: null,
      keyAction: "center_execute",
      keyService: "activity",
      exerciseSelected: [],
      itemActivityId: null,
      systemRoleLoading: false,
      begin_center_time: 0,
      person_show_complete_data_selected: null,
      companyName: "",
      person_code: null,
      center_execute_id: +this.$route.params.id,
      isLoading: false,
      isLoadingActivity: true,
      start_date: "",
      startDelay: "",
      company_id: null,
      modeEditExecutive: null,
      modalTitle: "",
      message: "",
      template_name: null,
      assesmet_plan_name: null,
      view_edit_DayCenterRoom: false,
      parentPermissions: [],
      assessorLoading: false,
      view_executive_select: false,
      view_activity: false,
      allowPermissions: ["admin", "edit"],
      title_person: null,
      executives_options: [],
      executive_role_id: null,
      assessor_replacement: null,
      assessor_replacement_options: [{ text: "انتخاب نشده", value: null }],
      assessor_replacement_loading: null,
      room_id: "",
      persons_options: [],
      person_selected: null,
      person_loading: false,
      person_executive_code: null,
      person_executive_id: null,
      center_execute_type: null,
      term: null,
      showUploadActivity: false,
      isLoadingExecutive: false,
      mode_activity: "",
      hiddenFieldsActivity: [
        "diff_time_checkpoint",
        "text",
        "time_checkpoint",
        "start_at_period",
        "start_at_time",
        "description",
      ],
      exerciseSelectedlist: [],
      buttonsAddDayCenter: [
        {
          id: "0",
          name: "edit",
          click: this.changeDayCenterRoom,
        },
        {
          id: "2",
          name: "view",
          click: this.changeDayCenterRoom,
        },
      ],
      buttonsCenterExecute: [
        {
          name: "delete",
          text: this.$lang.remove,
          iconName: "close",
          variant: "outline-danger",
          allowPermissions: ["admin"],
          centerExecuteState: [1, 2, 3],
          status: [0],
          click: this.showRemoveConfirm,
        },
        {
          name: "set_absent",
          text: this.$lang.set_absent,
          iconName: "account-cancel-outline",
          variant: "outline-danger",
          allowPermissions: ["admin"],
          centerExecuteState: [1, 2, 3],
          executiveRoles: [1],
          click: this.showAbsentModal,
        },
        {
          name: "edit",
          text: this.$lang.edit,
          iconName: "account-edit-outline",
          variant: "outline-success",
          allowPermissions: ["admin", "edit"],
          centerExecuteState: [1, 2, 3],
          status: [0, 1],
          click: this.editCenterExecute,
        },
        {
          name: "view",
          text: this.$lang.view,
          iconName: "account-eye-outline",
          variant: "outline-success",
          allowPermissions: ["view"],
          centerExecuteState: [4, 5],
          status: [0, 1],
          click: this.editCenterExecute,
        },
        {
          name: "upload_ready_report",
          text: this.$lang.upload_ready_report,
          iconName: "cloud-upload-outline",
          variant: "outline-primary",
          allowPermissions: ["admin", "edit", "view"],
          centerExecuteState: [1, 2, 3, 4, 5],
          executiveRoles: [1],
          click: this.showUploadReadyReportModal,
          checkCandidate: true,
        },
        {
          name: "reports",
          text: this.$lang.reports,
          iconName: "clipboard-list-outline",
          variant: "primary",
          allowPermissions: ["admin", "edit", "view"],
          centerExecuteState: [1, 2, 3, 4, 5],
          executiveRoles: [1],
          click: this.showReports,
          checkCandidate: true,
        },
      ],
      buttonsActivity: [
        {
          id: "0",
          name: "edit",
          click: this.changeCenterExecuteActivity,
        },
        {
          id: "1",
          name: "delete",
        },
        {
          id: "2",
          name: "view",
          click: this.changeCenterExecuteActivity,
        },
      ],
      items_exercise_prerequisites: [],
      loading_exercise_prerequisites: false,
      executiveMode: "add",
      modalLoading: false,
      modalLoadingText: this.$lang.receiving_data,
      executePersonPermissions: [],
      report_card_production_method_selected: null,
      center_execute_type_selected: null,
      set_absent: 0,
      absent_description: null,
      absentModal: false,
      absentLoading: false,
      readyReportModal: false,
      parvandehCode: null,
      centerExecuteCode: null,
      confirmData: {
        loading: false,
        show: false,
        title: this.$lang.report_modalTitle,
        description: this.$lang.report_message,
      },
      removeReportsConfirmData: {
        loading: false,
        show: false,
        title: this.$lang.removeAllAcReports,
        description: this.$lang.removeAllAcReportsConfirm,
        item: null,
      },
      reportsModal: false,
      reportParvandehCode: null,
      reportParvandehNumber: null,
      reportPersonCodeInAc: null,
      reportPersonName: "",
      confirmModal: false,
      confirmLoading: false,
      itemId: null,
      assessorReplacementTitle: "",
      reportSettingsModal: false,
      isPlaningPerson: 0,
      centerExecuteStatusId: null,
      activityPermissions: [],
    };
  },
  computed: {
    termCode() {
      return pathOr(null, ["code"], this.term);
    },
    termId() {
      return pathOr(null, ["id"], this.term);
    },
    role_options() {
      const options = renderEumOptions("executive_role");
      return this.executiveMode === "add"
        ? options.filter((x) => x.value > 2)
        : options;
    },
    roomUrl() {
      return generateApiUrl(
        ["kanoon", "center_execute_room"],
        [this.center_execute_id]
      );
    },
    executiveActivityUrl() {
      return generateApiUrl(
        ["kanoon", "activity"],
        [this.keyAction, this.center_execute_id]
      );
    },
    exercise_prerequisites_url() {
      return generateApiUrl(
        ["kanoon", "center_execute_exercise"],
        [this.center_execute_id]
      );
    },
    center_execute_executive_url() {
      return generateApiUrl(
        ["kanoon", "center_execute_person"],
        [this.center_execute_id]
      );
    },
    activityFormTitle() {
      return this.mode_activity === "add"
        ? this.$lang.addActivity
        : this.$lang.editActivity;
    },
    reportCardProductionMethodOptions() {
      return renderEumOptions("report_card_production_method");
    },
    person_show_complete_data_options() {
      return renderEumOptions("person_show_complete_data").map((item) => {
        return {
          id: pathOr(null, ["value"], item),
          caption: pathOr(null, ["text"], item),
        };
      });
    },
    enter_execute_type_options() {
      return renderEumOptions("center_execute_type");
    },
    extraButtons() {
      return [
        {
          name: "rebuildReport",
          condition: true,
          title: this.$lang.report_all_setting,
          click: this.showReportSettingsModal,
          iconName: "cog-transfer-outline",
        },
        {
          name: "rebuildReport",
          condition: true,
          title: this.$lang.removeAllAcReports,
          click: this.showRemoveReportsConfirm,
          iconName: "sticker-remove-outline",
        },
        {
          name: "rebuildReport",
          condition: true,
          title: this.$lang.rebuild,
          click: this.showConfirm,
          iconName: "recycle-variant",
        },
      ];
    },
  },
  watch: {
    assessor_replacement(value) {
      const originalAssessorValue = pathOr(
        null,
        ["value"],
        this.person_selected
      );
      const secondAssessorValue = pathOr(null, ["value"], value);

      if (
        originalAssessorValue &&
        secondAssessorValue &&
        originalAssessorValue === secondAssessorValue
      ) {
        this.assessor_replacement = null;
        return this.$notify.warning(
          "ارزیاب اصلی و ارزیاب دوم نمی توانند یکسان باشند"
        );
      }
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    renderEumOptions,
    isAdmin,
    updateExecutePersonPermissions(permissions) {
      this.executePersonPermissions = [...permissions];
    },
    availableButtonsPerson(item) {
      return this.buttonsCenterExecute.filter((x) => {
        const status = pathOr([], ["status"], x);
        const centerExecuteState = pathOr([], ["centerExecuteState"], x);
        const executiveRoles = pathOr([], ["executiveRoles"], x);
        const allowPermissions = pathOr([], ["allowPermissions"], x);

        let con =
          includes(item.is_planing_person, status) &&
          includes(item.center_execute_state, centerExecuteState);
        if (executiveRoles.length) {
          const itemExecutiveRole = pathOr(
            null,
            ["executive_role", "id"],
            item
          );
          con =
            includes(item.center_execute_state, centerExecuteState) &&
            includes(itemExecutiveRole, executiveRoles);
        }

        // check candidate
        const checkCandidate = pathOr(false, ["checkCandidate"], x);
        const isCandidate = pathOr(false, ["executive_role", "id"], item) === 1;
        if (checkCandidate && isCandidate) {
          const hasCandidate = pathOr(
            false,
            ["parvandeh", "person", "code"],
            item
          );
          con = con && hasCandidate;
        }

        // check is absent
        const isAbsent = !!pathOr(false, ["is_absent", "id"], item);
        con = con && !isAbsent;

        // check permissions
        con =
          con &&
          this.executePersonPermissions.some((item) =>
            includes(item, allowPermissions)
          );

        return con;
      });
    },
    changeValue() {
      this.exerciseSelected = this.exerciseSelectedlist
        .filter((x) => x.enable)
        .map((x) => {
          let row = true;
          return {
            ...x,
            row,
          };
        });
    },
    fillExerciseSelected(items) {
      this.exerciseSelectedlist = items;
    },
    async getExercisePrerequisites() {
      this.loading_exercise_prerequisites = true;
      try {
        const response = await this.$httpService.get(
          this.exercise_prerequisites_url
        );
        this.items_exercise_prerequisites = response.data.data;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading_exercise_prerequisites = false;
      }
    },
    async checkedExercisePrerequisites(item, event) {
      this.loading_exercise_prerequisites = true;
      try {
        let payload = {
          exercise_id: item.id,
          add: event ? 1 : 0,
        };
        const response = await this.$httpService.put(
          this.exercise_prerequisites_url,
          payload
        );
        this.$notify.success(response.data.message);
        this.getExercisePrerequisites();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading_exercise_prerequisites = false;
      }
    },
    tabTracker(tabIndex) {
      tabIndex === 4 && this.getExercisePrerequisites();
    },
    ActivityAddModal() {
      this.mode_activity = "add";
      this.view_activity = true;
      this.showUploadActivity = false;
      this.itemActivityId = null;
    },
    changeCenterExecuteActivity(item) {
      this.itemActivityId = pathOr(null, ["id"], item);
      this.mode_activity = "edit";
      this.view_activity = true;
      this.showUploadActivity = true;
    },
    chancelActivity() {
      this.mode_activity = "";
      this.view_activity = false;
      this.itemActivityId = null;
    },
    closeModal() {
      this.view_executive_select = false;
      this.clear();
    },
    clearModalConfirm() {
      this.modalTitle = "";
    },
    async setAbsentOrPresent() {
      this.$v.absent_description.$touch();
      if (this.$v.absent_description.$anyError) return;

      try {
        this.absentLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_absent"],
          [this.center_execute_id, this.person_executive_id]
        );
        const payload = {
          is_absent: 1,
          absent_description: this.absent_description,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeSetAbsentModal();
        this.$refs.center_executive_search.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.absentLoading = false;
      }
    },
    updateRoom() {
      this.$refs.roomSearch.getItems();
    },
    clear() {
      this.person_selected = null;
      this.executive_role_id = null;
      this.person_executive_code = null;
      this.assessor_replacement = null;
      this.persons_options = [];
      this.$v.$reset();
    },
    addCenterExecutive() {
      this.clear();
      this.executiveMode = "add";
      this.view_executive_select = true;
      this.title_person = this.$lang.executives;
      this.modeEditExecutive = null;
      this.person_executive_code = null;
      this.persons_options = this.executives_options;
      this.isPlaningPerson = 0;
    },
    async editCenterExecute(item) {
      this.clear();
      this.executiveMode = "edit";

      const isAbsentId = pathOr(null, ["is_absent", "id"], item);
      if (isAbsentId === 1) {
        return this.$notify.error(this.$lang.is_absent_true);
      }

      this.person_selected = item.parvandeh
        ? {
            text: `${pathOr(
              "",
              ["parvandeh", "parvandeh_number"],
              item
            )} - ${pathOr("", ["parvandeh", "person", "name"], item)} ${pathOr(
              "",
              ["parvandeh", "person", "family"],
              item
            )} - ${pathOr("", ["parvandeh", "person", "national_code"], item)}`,
            value: pathOr("", ["parvandeh", "code"], item),
          }
        : null;
      this.assessor_replacement = item.second_assessor_parvandeh
        ? {
            text: `${pathOr(
              "",
              ["second_assessor_parvandeh", "parvandeh_number"],
              item
            )} - ${pathOr(
              "",
              ["second_assessor_parvandeh", "person", "name"],
              item
            )} ${pathOr(
              "",
              ["second_assessor_parvandeh", "person", "family"],
              item
            )} - ${pathOr(
              "",
              ["second_assessor_parvandeh", "person", "national_code"],
              item
            )}`,
            value: pathOr("", ["second_assessor_parvandeh", "code"], item),
          }
        : null;
      this.modeEditExecutive = pathOr(null, ["executive_role", "id"], item);
      this.title_person = pathOr("", ["executive_role", "caption"], item);

      this.assessorReplacementTitle =
        this.modeEditExecutive === 2
          ? this.$lang.assessor_replacement
          : this.$lang.assistant_ac_manager;

      this.person_executive_code = pathOr(
        null,
        ["person_center_execute_code"],
        item
      );
      this.person_executive_id = pathOr(null, ["id"], item);
      this.executive_role_id = this.role_options.find(
        (x) => x.value === this.modeEditExecutive
      );
      this.isPlaningPerson = +pathOr(0, ["is_planing_person"], item);
      this.view_executive_select = true;
    },
    async add_executives() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      try {
        this.isLoadingExecutive = true;
        let payload = {
          parvandeh_code: pathOr(null, ["value"], this.person_selected),
          executive_role_id: pathOr(null, ["value"], this.executive_role_id),
          person_center_execute_code: this.person_executive_code,
        };
        const response = await this.$httpService.post(
          this.center_execute_executive_url,
          payload
        );
        this.closeModal();
        this.$notify.success(response.data.message);
        this.$refs.center_executive_search.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoadingExecutive = false;
      }
    },
    async edit_executives() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoadingExecutive = true;
        const id = this.person_executive_id || null;
        const url = generateApiUrl(
          ["kanoon", "center_execute_person_id"],
          [this.center_execute_id, id]
        );
        const payload = {
          parvandeh_code: pathOr(null, ["value"], this.person_selected),
          executive_role_id: pathOr(null, ["value"], this.executive_role_id),
          person_center_execute_code: this.person_executive_code,
          second_assessor_parvandeh_code: pathOr(
            null,
            ["value"],
            this.assessor_replacement
          ),
        };

        if (includes(this.modeEditExecutive, [1, 2])) {
          delete payload.person_center_execute_code;
        }

        const response = await this.$httpService.put(url, payload);
        this.closeModal();
        this.$notify.success(response.data.message);
        this.$refs.center_executive_search.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoadingExecutive = false;
      }
    },
    async getPersonCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.persons_options = [];
      }

      try {
        this.person_loading = true;

        let apiUrlKeys = [];
        let apiUrlReplacements = [];
        let queryParams = { search_txt: query };
        if (this.modeEditExecutive === 1) {
          apiUrlKeys = ["kanoon", "term_parvandeh_combo"];
          apiUrlReplacements = [this.termCode];
        } else {
          /* guidance: if modeEditExecutive is 1 => is person else is executives */
          apiUrlKeys = ["kanoon", "executives"];
          apiUrlReplacements = [];
        }
        const url = generateApiUrl(apiUrlKeys, apiUrlReplacements, queryParams);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.persons_options = data.map((x) => {
          return {
            text: `${pathOr(
              "",
              ["parvandeh", "parvandeh_number"],
              x
            )} - ${pathOr("", ["parvandeh", "person", "name"], x)} ${pathOr(
              "",
              ["parvandeh", "person", "family"],
              x
            )} - ${pathOr("", ["parvandeh", "term", "caption"], x)}`,
            value: pathOr("", ["parvandeh", "code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.person_loading = false;
      }
    },
    async getPersonCombo2(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.assessor_replacement_options = [
          { text: "انتخاب نشده", value: null },
        ];
      }

      try {
        this.assessor_replacement_loading = true;
        const queryParams = { search_txt: query };
        const url = generateApiUrl(["kanoon", "executives"], [], queryParams);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        const options = data.map((x) => {
          return {
            text: `${pathOr(
              "",
              ["parvandeh", "parvandeh_number"],
              x
            )} - ${pathOr("", ["parvandeh", "person", "name"], x)} ${pathOr(
              "",
              ["parvandeh", "person", "family"],
              x
            )} - ${pathOr("", ["parvandeh", "term", "caption"], x)}`,
            value: pathOr("", ["parvandeh", "code"], x),
          };
        });
        this.assessor_replacement_options = [
          { text: "انتخاب نشده", value: null },
          ...options,
        ];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.assessor_replacement_loading = false;
      }
    },
    async patchCreateReport(item) {
      try {
        const id = pathOr(null, ["id"], item);
        const isCreateReport = +pathOr(true, ["is_create_report"], item);
        const url = generateApiUrl(
          ["kanoon", "center_execute_create_report"],
          [this.centerExecuteCode, id]
        );
        const payload = {
          is_create_report: isCreateReport,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
        item.is_create_report = !item.is_create_report;
      }
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    closeDayCenterRoom() {
      this.view_edit_DayCenterRoom = false;
    },
    changeDayCenterRoom(item) {
      this.room_id = item.id.toString();
      this.view_edit_DayCenterRoom = true;
    },
    async remove_executive() {
      try {
        this.confirmLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_parvandeh"],
          [this.center_execute_id, this.itemId]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    remove_room(item) {
      return this.$httpService
        .delete(this.roomUrl + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    async remove_activity(item) {
      try {
        this.isLoading = true;
        const id = pathOr(null, ["id"], item);
        const url = generateApiUrl(
          ["kanoon", "activity_id"],
          [this.keyAction, this.center_execute_id, id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      try {
        this.isLoading = true;
        const payload = {
          start_date: this.start_date,
          begin_center_time: +this.begin_center_time,
          is_person_show_complete_data: pathOr(
            null,
            ["id"],
            this.person_show_complete_data_selected
          ),
          caption: this.caption,
          report_card_production_method_id: pathOr(
            null,
            ["value"],
            this.report_card_production_method_selected
          ),
          center_execute_type_id: pathOr(
            null,
            ["value"],
            this.center_execute_type_selected
          ),
        };
        const url = generateApiUrl(
          ["kanoon", "center_execute_id"],
          [this.center_execute_id]
        );
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      if (!this.center_execute_id) return;
      try {
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_id"],
          [this.center_execute_id]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.parentPermissions = response.data.permissions;
        this.start_date = pathOr(null, ["start_date", "gregorian"], data);
        this.startDelay = pathOr("", ["start_delay"], data);
        this.template_name = pathOr(null, ["template", "caption"], data);
        this.companyName = pathOr(null, ["company", "name"], data);
        this.caption = pathOr(null, ["caption"], data);
        this.center_number = pathOr(null, ["id"], data);
        this.center_execute_type = pathOr(null, ["center_execute_type"], data);
        this.centerExecuteCode = pathOr(null, ["code"], data);
        this.term = pathOr(null, ["term"], data);
        this.begin_center_time = pathOr(
          null,
          ["begin_center_time", "id"],
          data
        );
        this.assesmet_plan_name = pathOr(
          null,
          ["assessment_plan", "name"],
          data
        );
        this.person_show_complete_data_selected = pathOr(
          null,
          ["person_show_complete_data"],
          data
        );

        this.template_selected = {
          value: pathOr(null, ["template", "id"], data),
          text: pathOr(null, ["template", "caption"], data),
        };
        this.report_card_production_method_selected = {
          value: pathOr(null, ["report_card_production_method", "id"], data),
          text: pathOr(
            null,
            ["report_card_production_method", "caption"],
            data
          ),
        };

        this.company_id = pathOr(null, ["company", "code"], data);
        this.center_execute_type_selected = {
          text: pathOr(null, ["center_execute_type", "caption"], data),
          value: pathOr(null, ["center_execute_type", "id"], data),
        };
        this.centerExecuteStatusId = pathOr(null, ["status", "id"], data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async submit(payload, allowAddAttachmentCode = true) {
      try {
        this.modalLoadingText = this.$lang.sending_data;
        this.modalLoading = true;
        let response = null;
        if (this.mode_activity === "add") {
          response = await this.$httpService.post(
            this.executiveActivityUrl,
            payload
          );
          const id = pathOr(null, ["data", "data"], response);
          if (id && this.responseCode.length && allowAddAttachmentCode) {
            await this.finalSave(id);
          }
        } else {
          const url = generateApiUrl(
            ["kanoon", "activity_id"],
            [this.keyAction, this.center_execute_id, this.itemActivityId]
          );
          response = await this.$httpService.put(url, payload);
        }
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.modalLoading = false;
        this.view_activity = false;
        this.$refs.activitySearch.getItems();
      }
    },
    setResponseCode(code) {
      this.responseCode = code;
    },
    async finalSave(id) {
      try {
        const payload = {
          data: [],
        };
        for (const item of this.responseCode) {
          payload.data.push({
            code: item.code,
            attachment_type_id: 34,
            attachment_type_name: "attachment_type_azmoon_activity",
          });
        }
        const result = await this.attachmentTempFinalRepository.create(
          payload,
          "activity",
          id
        );
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    showAbsentModal(item) {
      this.set_absent = +pathOr(false, ["is_absent", "id"], item);
      this.person_executive_id = pathOr(null, ["id"], item);
      this.absentModal = true;
    },
    showUploadReadyReportModal(item) {
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      this.reportPersonName = pathOr(
        null,
        ["parvandeh", "person", "name"],
        item
      );
      this.readyReportModal = true;
    },
    showConfirm() {
      this.confirmData.show = true;
    },
    showRemoveReportsConfirm(item) {
      this.removeReportsConfirmData.item = item;
      this.removeReportsConfirmData.show = true;
    },
    closeRemoveReportsConfirm() {
      this.removeReportsConfirmData.item = null;
      this.removeReportsConfirmData.show = false;
    },
    async removeAllAcReports() {
      try {
        this.removeReportsConfirmData.loading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_report"],
          [this.centerExecuteCode]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.$refs.center_executive_search.getItems();
        this.removeReportsConfirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.removeReportsConfirmData.loading = false;
      }
    },
    async rebuildReport() {
      try {
        this.confirmData.loading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_report"],
          [this.centerExecuteCode]
        );
        const response = await this.$httpService.patch(url);
        this.$notify.success(response.data.message);
        this.confirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    showReports(item) {
      this.reportParvandehCode = pathOr(null, ["parvandeh", "code"], item);
      this.reportParvandehNumber = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      this.reportPersonCodeInAc = pathOr(
        null,
        ["person_center_execute_code"],
        item
      );
      this.reportPersonName = pathOr(
        null,
        ["parvandeh", "person", "name"],
        item
      );
      this.reportsModal = true;
    },
    showRemoveConfirm(item) {
      this.itemId = pathOr(null, ["id"], item);
      this.confirmModal = true;
    },
    closeSetAbsentModal() {
      this.absent_description = null;
      this.absentModal = false;
    },
    showReportSettingsModal() {
      this.reportSettingsModal = true;
    },
    closeReportSettingsModal() {
      this.reportSettingsModal = false;
    },
    createReportConditions(item) {
      const centerExecuteState = pathOr([], ["center_execute_state"], item);
      const itemExecutiveRole = pathOr(null, ["executive_role", "id"], item);

      return (
        includes(centerExecuteState, [1, 2, 3, 4, 5]) &&
        includes(itemExecutiveRole, [1])
      );
    },
    updateActivityPermissions(permissions) {
      this.activityPermissions = [...permissions];
    },
  },
};
</script>
